<template>
<div class="portfolioForm">
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    width="70%"
     v-dialogDrag
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8" icon="el-icon-edit" :type="method == 'view' ? 'warning' :'primary'"  :plain="method == 'view' ? false : true"  @click="handEditorView(method)" :disabled="!hasPermission('cecunmportfolio:cecUnmPortfolio:edit')">编辑</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="150px">
      <el-row type="flex" style="flex-wrap:wrap">
        <el-col :span="24">
          <el-divider content-position="left">产品基本信息</el-divider>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col><el-col :span="12">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                  {required: true, message:'中文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="户型" prop="region"
                :rules="[
                  {required: true, message:'户型不能为空', trigger:'blur'}
                 ]">
                 <el-input-number v-model="inputForm.bed" @change="handRegionText" :min="1" :max="100" style="width: 100px;"></el-input-number>
                 <span style="padding:0 20px;font-size:15px">Bed</span>
                 <el-input-number v-model="inputForm.bath" @change="handRegionText" :min="1" :max="100" style="width: 100px;"></el-input-number>
                 <span style="padding:0 20px;font-size:15px">Bath</span>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="排序" prop="sort"
                :rules="[
                  {required: true, message:'排序不能为空', trigger:'blur'}
                 ]">
              <el-input v-model.number="inputForm.sort" placeholder="请填写排序"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="状态" prop="state"
                :rules="[
                  {required: true, message:'状态不能为空', trigger:'blur'}
                 ]">
                 <!-- <el-select v-model="inputForm.state" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in stateOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select> -->
                  <StateSelect ref="stateSelectRef" v-model="inputForm.state" :option="stateOption" @searchChange="handSelect"></StateSelect>
           </el-form-item>
        </el-col>
        <el-col :span="12">
                <el-form-item label="创建时间" prop=""
                    :rules="[
                    ]">
                    <el-date-picker
                      disabled
                      v-model="inputForm.createDate"
                      type="datetime"
                      style="width: 100%;"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="pickerOptions">
                    </el-date-picker>
              </el-form-item>
            </el-col>
        <el-col :span="12">
            <el-form-item label="面积" prop="size"
                :rules="[
                  {required: true, message:'面积不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.size" placeholder="请填写面积" style="width: 80%;" @input="handleInput($event,'size')"  @focus="focusInput($event,'size')" @blur="blurInput($event,'size')"></el-input>
              <span style="padding:0 20px;font-size:15px">sqft</span>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="地区" prop="houseType"
                :rules="[
                  {required: true, message:'地区不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.houseType" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in $dictUtils.getDictList('cec_district')"
                            :key="item.value"
                            :label="item.labelEn"
                            :value="item.value">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="价格" prop="price"
                :rules="[
                  {required: true, message:'价格不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.price" placeholder="请填写价格" @input="handleInput($event,'price')"  @focus="focusInput($event,'price')" @blur="blurInput($event,'price')" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="类型" prop="type"
                :rules="[
                  {required: true, message:'类型不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.type" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in $dictUtils.getDictList('cec_portfolio_type')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否在首页显示" prop="showHome">
                 <!-- <el-select v-model="inputForm.showHome" placeholder="请选择"  style="width: 100%;">
                    <el-option
                      v-for="item in $dictUtils.getDictList('yes_no')"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select> -->
                  <el-radio-group v-model="inputForm.showHome">
                    <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('yes_no')" :key="item.id">{{ item.label }}</el-radio>
                  </el-radio-group>
           </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标签" prop=""
            :rules="[
              ]">
              <tagSelect ref="tagSelectRef" :value="inputForm.tagsIds" @searchChange="handTagSelect" @addTagCloud="addTagCloud" associationType="1"></tagSelect>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-divider content-position="left">主图</el-divider>
        </el-col>
        <el-col :span="8">
            <el-form-item label="列表主图" prop="listImage"
                :rules="[
                  {required: true, message:'列表主图不能为空', trigger:'change'}
                 ]">
                  <CropperView
                    ref="listImageRef"
                    :imgSrc="inputForm.listImageSrc"  
                    :disabled="method==='view'" 
                    :actionButtonFlag="true"
                    :ifSetUploadName="true" 
                    :autoCropWidth="480"
                    :autoCropHeight="480"
                    :updateParams="{
                      fileName: inputForm.nameEn,
                      tip: '请先输入英文名称',
                      code: 'listImage'
                    }"
                    :objectFit="'cover'" 
                    :listIndex="1"
                    :otherPrams="otherPrams" 
                    tip="单个图片不要超过10M" 
                    @updateChange="handImageList($event,'listImage','cropper')"
                  ></CropperView>
           </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="详情主图" prop="mainImage"
                :rules="[
                  {required: true, message:'详情主图不能为空', trigger:'change'}
                 ]">
                 <CropperView 
                  ref="mainImageRef"
                  :imgSrc="inputForm.mainImageSrc"  
                  :disabled="method==='view'" 
                  :actionButtonFlag="true"
                  :ifSetUploadName="true" 
                  :autoCropWidth="1080"
                  :autoCropHeight="530"
                  :updateParams="{
                    fileName: inputForm.nameEn,
                    tip: '请先输入英文名称',
                    code: 'mainImage'
                  }"
                  :objectFit="'cover'" 
                  :listIndex="1"
                  :otherPrams="otherPrams" 
                  tip="单个图片不要超过10M" 
                  @updateChange="handImageList($event,'mainImage','cropper')">
                  </CropperView>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
          <el-divider content-position="left">设计</el-divider>
        </el-col>
        <el-col :span="8" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
            <el-form-item label="是否在详情显示" prop="showDesign">
                  <el-radio-group v-model="inputForm.showDesign">
                    <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('yes_no')" :key="item.id">{{ item.label }}</el-radio>
                  </el-radio-group>
           </el-form-item>
        </el-col>
        <el-col :span="8" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
            <el-form-item label="设计前图" prop="beforeImage"
                :rules="[
                  {required: inputForm.showDesign == '1' ? true : false , message:'设计前图不能为空', trigger:'change'}
                ]">
                <CropperView 
                ref="beforeImageRef"
                :imgSrc="inputForm.beforeImageSrc"  
                :disabled="method==='view'" 
                :actionButtonFlag="true"
                :ifSetUploadName="true" 
                :autoCropWidth="600"
                :autoCropHeight="500"
                :updateParams="{
                  fileName: inputForm.nameEn,
                  tip: '请先输入英文名称',
                  code: 'beforeImage'
                }"
                :objectFit="'cover'" 
                :listIndex="1"
                :otherPrams="otherPrams" 
                tip="单个图片不要超过10M" 
                @updateChange="handImageList($event,'beforeImage','cropper')">
                </CropperView>
          </el-form-item>
        </el-col>
        <el-col :span="8" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
            <el-form-item label="设计后图" prop="afterImage"
                :rules="[
                  {required:  inputForm.showDesign == '1' ? true : false, message:'设计后图不能为空', trigger:'change'}
                ]">
                <CropperView 
                ref="afterImageRef" 
                :imgSrc="inputForm.afterImageSrc"  
                :disabled="method==='view'" 
                :actionButtonFlag="true"
                :ifSetUploadName="true" 
                :autoCropWidth="600"
                :autoCropHeight="500"
                :updateParams="{
                  fileName: inputForm.nameEn,
                  tip: '请先输入英文名称',
                  code: 'afterImage'
                }"
                :objectFit="'cover'" 
                :listIndex="1"
                :otherPrams="otherPrams" 
                tip="单个图片不要超过10M" 
                @updateChange="handImageList($event,'afterImage','cropper')">
                </CropperView>
          </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
          <el-form-item label="设计后描点" prop=""
            :rules="[
              ]">
              <designPoint ref="designPointRef" title="设计后" pointType="design" :disabled="method==='view'" :valueList="inputForm.portfolioPoint" :backgroundImage="afterPonitImage"></designPoint>
           </el-form-item>
        </el-col>
        <el-col :span="12" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
            <el-form-item label="设计标题（英）" prop="designTitleEn"
                :rules="[
                  {required:  inputForm.showDesign == '1' ? true : false, message:'设计标题（英）不能为空', trigger:'blur'}
                 ]">
              <el-input  v-model="inputForm.designTitleEn" placeholder="请填写英文设计标题"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
            <el-form-item label="设计标题（中）" prop="designTitleCn"
                :rules="[
                  {required:  inputForm.showDesign == '1' ? true : false, message:'设计标题（中）不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.designTitleCn" placeholder="请填写中文设计标题"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
            <el-form-item label="设计内容（英）" prop="designConceptEn"
                :rules="[
                  {required:  inputForm.showDesign == '1' ? true : false, message:'设计内容（英）不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5}" v-model="inputForm.designConceptEn" placeholder="请填写英文设计内容"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showDesign == '0' ? 'opacity5' : ''">
            <el-form-item label="设计内容（中）" prop="designConceptCn"
                :rules="[
                  {required:  inputForm.showDesign == '1' ? true : false, message:'设计内容（中）不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5}" v-model="inputForm.designConceptCn" placeholder="请填写中文设计内容"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showMaterials == '0' ? 'opacity5' : ''">
          <el-divider content-position="left">材料</el-divider>
        </el-col>
        <el-col :span="12" :class="inputForm.showMaterials == '0' ? 'opacity5' : ''">
            <el-form-item label="是否在详情显示" prop="showMaterials">
                  <el-radio-group v-model="inputForm.showMaterials">
                    <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('yes_no')" :key="item.id">{{ item.label }}</el-radio>
                  </el-radio-group>
           </el-form-item>
        </el-col>
        <el-col :span="12" :class="inputForm.showMaterials == '0' ? 'opacity5' : ''">
            <el-form-item label="材料包装主图片" prop="itemImage"
                :rules="[
                  {required: inputForm.showMaterials == '1' ? true : false, message:'材料包装主图片不能为空', trigger:'change'}
                 ]">
                 <CropperView 
                  ref="itemImageRef" 
                  :imgSrc="inputForm.itemImageSrc"  
                  :disabled="method==='view'" 
                  :actionButtonFlag="true"
                  :ifSetUploadName="true" 
                  :autoCropWidth="1000"
                  :autoCropHeight="500"
                  :updateParams="{
                    fileName: inputForm.nameEn,
                    tip: '请先输入英文名称',
                    code: 'itemImage'
                  }"
                  :objectFit="'cover'" 
                  :listIndex="1"
                  :otherPrams="otherPrams" 
                  tip="单个图片不要超过10M" 
                  @updateChange="handImageList($event,'itemImage','cropper')">
                  </CropperView>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showMaterials == '0' ? 'opacity5' : ''">
          <el-form-item label="材料主图描点" prop=""
            :rules="[
              ]">
              <designPoint ref="materialsPointRef" title="材料主图" pointType="materials" :disabled="method==='view'" :valueList="inputForm.portfolioPointMaterials" :backgroundImage="materialsImage"></designPoint>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showMaterials == '0' ? 'opacity5' : ''">
            <el-form-item label="材料包装其他图片集" prop="itemImageList"
                :rules="[
                  {required: inputForm.showMaterials == '1' ? true : false, message:'材料包装其他图片集不能为空', trigger:'change'}
                 ]">
                 <ImageUploadDraggableBtn  
                 ref="itemImageJsonRef" 
                 v-model="inputForm.itemImageList" 
                 :ifSetUploadName="true" 
                 :itemActivityForm="true" 
                 :ownerId="inputForm.id" 
                 :uploadInfo="{type:'itemImageList',title:'材料包装其他图片集' ,category: 'portfolio',categoryName: '产品图册',tip:'请先输入英文名称',fileName: inputForm.nameEn,}" 
                 :setTable="true" 
                 :draggable="true"   
                 :disabled="method==='view'"  
                 :otherPrams="otherPrams" 
                 action="/unmfile/cecUnmFileupload"  
                 tip="单个图片不要超过10M" 
                 @updateChange="handImageList($event,'itemImageList')">
                 </ImageUploadDraggableBtn>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showMaterials == '0' ? 'opacity5' : ''">
            <el-form-item label="材料内容（英）" prop="itemConceptEn"
                :rules="[
                  {required: inputForm.showMaterials == '1' ? true : false, message:'材料内容（英）不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5}" v-model="inputForm.itemConceptEn" placeholder="请填写英文材料包装内容"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showMaterials == '0' ? 'opacity5' : ''">
            <el-form-item label="材料内容（中）" prop="itemConceptCn"
                :rules="[
                  {required: inputForm.showMaterials == '1' ? true : false, message:'材料内容（中）不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5}" v-model="inputForm.itemConceptCn" placeholder="请填写中文材料包装内容"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
          <el-divider content-position="left">其他图片</el-divider>
        </el-col>
        <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
            <el-form-item label="是否在详情显示" prop="showGallery">
                  <el-radio-group v-model="inputForm.showGallery">
                    <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('yes_no')" :key="item.id">{{ item.label }}</el-radio>
                  </el-radio-group>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
            <el-form-item label="展览集" prop="gallery"
                :rules="[
                  {required: inputForm.showGallery == '1' ? true : false, message:'展览集不能为空', trigger:'change'}
                 ]">
                 <ImageUploadDraggableBtn 
                 v-model="inputForm.gallery" 
                 :draggable="true" 
                 :itemActivityForm="true" 
                 :ifSetUploadName="true" 
                 :ownerId="inputForm.id" 
                 :uploadInfo="{type:'gallery',title:'展览集',category: 'portfolio',categoryName: '产品图册',tip:'请先输入英文名称',fileName: inputForm.nameEn}"  
                 :disabled="method==='view'"  
                 :otherPrams="otherPrams" 
                 action="/unmfile/cecUnmFileupload"  
                 tip="单个图片不要超过10M,可拖动列表行排序"
                  @updateChange="handImageList($event,'gallery')"></ImageUploadDraggableBtn>
                 <!-- <itemUpload :itemId="inputForm.id" :itemCode="inputForm.code" :owner="inputForm.id" eventCode="Item" picHeight="400" :fontSize="90" :readOnly="method == 'view'" ref="itemUpload"></itemUpload> -->
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="danger"  icon="el-icon-close" @click="visible = false">关闭</el-button>
      <el-button size="medium" type="success" icon="el-icon-check" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmPortfolioService from '@/api/cecunmportfolio/cecUnmPortfolioService'
  import ImageUploadDraggable from '@/components/upload/ImageUploadDraggable'
  import ImageUploadInput from '@/components/upload/ImageUploadInput'
  import setTagTableArray from '@/components/gridSelect/setTagTableFile'
  import ImageUploadDraggableBtn from '@/components/upload/ImageUploadDraggableBtn'
  import CropperView from '@/components/upload/ImageUploadCropper.vue'
  import designPoint from '@/components/point'
  import itemUpload from '@/components/file/itemUpload'
  import tags from '@/components/tags'
  import StateSelect from '@/components/select'
  import tagSelect from '@/components/select/tagSelect'
  import _ from 'lodash'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          sort: '',
          nameEn: '',
          nameCn: '',
          size: '',
          region: '',
          regionList: [],
          houseType: '',
          price: '',
          type: '',
          state: '',
          listImageId: '',
          listImage: [],
          listImageSrc: '',
          mainImageId: '',
          mainImage: [],
          mainImageSrc: '',
          beforeImageId: '',
          beforeImage: [],
          beforeImageSrc: '',
          afterImageId: '',
          afterImageSrc: '',
          afterImage: [],
          designConceptEn: '',
          designConceptCn: '',
          designTitleEn: '',
          designTitleCn: '',
          itemImageId: '',
          itemImage: [],
          itemImageSrc: '',
          itemImageJson: '',
          itemImageList: [],
          itemConceptEn: '',
          itemConceptCn: '',
          galleryIds: '',
          showHome: '0',
          showGallery: '1',
          showMaterials: '1',
          showDesign: '1',
          gallery: [],
          portfolioPoint: [],
          portfolioPointMaterials: [],
          bath: 1,
          bed: 1,
          // tagsList: [],
          tagsIds: '',
          tags: [],
          createDate: ''
        },
        tagList: [],
        stateOption: [
          { value: '0', label: '上线' },
          { value: '2', label: '草稿' },
          { value: '1', label: '下线' }
        ],
        otherPrams: {
          id: '',
          type: 'portfolio'
        },
        afterPonitImage: '',
        materialsImage: '',
        formatter: null,
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '昨天',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周前',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        }
      }
    },
    components: {
      ImageUploadDraggable,
      ImageUploadInput,
      setTagTableArray,
      ImageUploadDraggableBtn,
      designPoint,
      itemUpload,
      tags,
      CropperView,
      StateSelect,
      tagSelect
    },
    methods: {
      addTagCloud () {
        this.$emit('addTagCloud')
      },
      handSelect (e) {
        this.inputForm.state = e
      },
      handTagSelect (e) {
        this.inputForm.tagsIds = e ? e.join(',') : ''
      },
      /** 输入框变化 */
      handleInput (value, type) {
        if (value === '') return
        const regex = /^\d+(\.\d*)?$/ // 使用正则表达式匹配 正整数 或小数点位数不限制的浮点数
        let formattedValue = value
        // 如果输入值不符合正则表达式，则将其设置为上一个有效值
        if (!regex.test(value)) {
          formattedValue = value.replace(/,/g, '').replace(/\D/g, '')
          // this.inputForm[type] = value.slice(0, value.length - 1)
          // this.handleInput(this.inputForm[type], type)
        }
        this.inputForm[type] = formattedValue
      },
      /** 输入框获得焦点 */
      focusInput (e, type) {
        if (e) return
        const val = e
        this.inputForm[type] = this.moneyToNumber(val) // 千分位转数值
      },
      /** 输入框失去焦点 */
      blurInput (e, type) {
        let val = e.target.value
        val = !val ? '' : Number(val)
        this.inputForm[type] = this.formateMoney(val) // 数值转为千分位格式
      },
      formateMoney (number) {
        return number.toLocaleString('zh-CN')
      },
      moneyToNumber (str) {
        // 使用正则表达式去除千分位分隔符（逗号）
        const cleanStr = str.replace(/,/g, '')
        // 将清理后的字符串转换为数值类型
        const number = parseFloat(cleanStr)
        return number
      },
      // 拼接户型
      handRegionText () {
        let regionObj = {
          BedroomNum: this.inputForm.bed,
          BathroomNum: this.inputForm.bath,
          regionText: this.inputForm.bed + 'Bed ' + this.inputForm.bath + 'Bath'
        }
        this.inputForm.region = JSON.stringify(regionObj)
      },
      handRegion (e) {
        let regionJson = e.map(item => {
          let obj = {
            id: item.id,
            label: item.label,
            labelEn: item.labelEn,
            num: item.num
          }
          return obj
        })
        this.inputForm.region = JSON.stringify(regionJson)
        this.inputForm.regionList = e
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      handImageIds (e, type) {
        this.inputForm[type] = e
      },
      // 上传返回ids
      handImageList: _.debounce(function (e, type, uploadType) {
        const that = this
        let mapList = uploadType === 'cropper' ? [e] : e
        that.inputForm[type] = mapList.map(item => {
          let ritem = {
            fileName: item.fileName,
            name: item.name,
            fileSize: item.size ? item.size : item.fileSize,
            url: item.url,
            filePath: item.filePath ? item.filePath : item.url,
            category: item.category ? item.category : 'portfolio_' + type,
            description: item.description ? item.description : '',
            actorId: item.actorId,
            actorName: item.actorName,
            categoryName: item.categoryName,
            startTime: item.startTime,
            createDate: item.createDate,
            pixel: item.pixel
          }
          return ritem
        })
        if (type === 'afterImage') {
          that.afterPonitImage = that.$refs.afterImageRef.previewImg
        } else if (type === 'itemImage') {
          that.materialsImage = that.$refs.itemImageRef.previewImg
        }
      }, 500),
      // 初始化操作
      init (method, id) {
        this.getMaxSort()
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建产品图册`
          this.inputForm.region = JSON.stringify({
            BedroomNum: 1,
            BathroomNum: 1,
            regionText: '1Bed 1Bath'
          })
          // this.inputForm.tagsList = []
          this.inputForm.mainImageSrc = ''
          this.inputForm.listImageSrc = ''
          this.inputForm.afterImageSrc = ''
          this.inputForm.beforeImageSrc = ''
          this.inputForm.tagsIds = ''
        } else if (method === 'edit') {
          this.title = '修改产品图册'
        } else if (method === 'view') {
          this.title = '查看产品图册'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.tagSelectRef.getTagCloud()
          // this.$refs.tagsRef.showKeyWord = false
          this.clearForm()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmPortfolioService.queryById(id).then(({data}) => {
              this.otherPrams.id = data.id
              this.inputForm = this.recover(this.inputForm, data)
              // this.inputForm.tagsList = data.tags ? data.tags.split(',') : []
              // if (data.itemImageJson) {
              //   this.inputForm.itemImageList = JSON.parse(data.itemImageJson)
              // } else {
              //   this.inputForm.itemImageList = []
              // }
              this.inputForm.itemImageList = data.itemImageList
              if (data.region) {
                let regionObj = JSON.parse(data.region)
                this.inputForm.bed = regionObj.BedroomNum
                this.inputForm.bath = regionObj.BathroomNum
              } else {
                this.inputForm.bed = ''
                this.inputForm.bath = ''
              }
              if (data.afterImage.length > 0) {
                this.afterPonitImage = process.env.VUE_APP_SERVER_URL + data.afterImage[0].filePath
              }
              if (data.itemImage.length > 0) {
                this.materialsImage = process.env.VUE_APP_SERVER_URL + data.itemImage[0].filePath
              }
              if (data.listImage.length > 0) {
                this.inputForm.listImageSrc = process.env.VUE_APP_SERVER_URL + data.listImage[0].filePath
              }
              if (data.mainImage.length > 0) {
                this.inputForm.mainImageSrc = process.env.VUE_APP_SERVER_URL + data.mainImage[0].filePath
              }
              this.loading = false
            })
          }
        })
      },
      getMaxSort () {
        cecUnmPortfolioService.getMaxSort().then(({data}) => {
          if (data) {
            this.inputForm.sort = data + 1
          }
        })
      },
      clearForm () {
        this.inputForm.listImage = []
        this.inputForm.mainImage = []
        this.inputForm.beforeImage = []
        this.inputForm.afterImage = []
        this.inputForm.itemImage = []
        this.inputForm.itemImageList = []
        this.inputForm.gallery = []
        this.inputForm.regionList = []
        this.inputForm.portfolioPoint = []
        this.inputForm.portfolioPointMaterials = []
        this.afterPonitImage = ''
        this.inputForm.bed = ''
        this.inputForm.bath = ''
        this.inputForm.tags = []
        this.$refs.listImageRef.resetFields()
        this.$refs.mainImageRef.resetFields()
        this.$refs.beforeImageRef.resetFields()
        this.$refs.afterImageRef.resetFields()
        this.$refs.itemImageRef.resetFields()
        this.$refs.inputForm.resetFields()
      },
      // 表单提交
      doSubmit () {
        this.inputForm.nameEn = this.inputForm.nameEn.toUpperCase()
        this.inputForm.itemImageList = this.$refs.itemImageJsonRef.itemActivityList
        this.inputForm.portfolioPoint = this.$refs.designPointRef.tableList
        this.inputForm.portfolioPointMaterials = this.$refs.materialsPointRef.tableList
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmPortfolioService.save(this.inputForm).then(({data}) => {
              if (data.state === '200') {
                this.visible = false
                this.$message.success(data.msg)
                this.$emit('refreshDataList')
              } else {
                this.$message.error('保存失败,' + data.msg)
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
 ::v-deep .el-dialog__body{
  padding: 10px 20px !important;
}
.opacity5{
  opacity: 0.5;
}
</style>

  
